import { Box, Divider, List, Paper, Stack } from '@mui/material';
import { FieldValues, FormProvider, SubmitHandler, useFormContext } from 'react-hook-form';
import { HiOutlineBanknotes } from 'react-icons/hi2';
import {
  LuEyeOff,
  LuFileClock,
  LuGlobe,
  LuGraduationCap,
  LuLanguages,
  LuMap,
  LuSearch,
} from 'react-icons/lu';
import { WsColors, WsInputNumber, WsSelect } from 'wisestep-base';

import { WsAccordion } from '../../../../components/filters/components';
import CheckboxListFilter from '../../../../components/filters/components/CheckboxListFilter';
import AdvancedFiltersHeader from '../../../../utils/AdvancedFiltersHeader';
import BasicSearchForm from '../../types/IBasicSearchForm';
import CareerBuilderAdvanceSearch from '../types/ICWJobsAdvanceSearch';
import {
  countriesCheckBoxOptions,
  HideCandidatesViewedSinceOptions,
  highestLevelOfEducationCheckBoxOptions,
  jobHoursOptions,
  languagesCheckBoxOptions,
  relocateOptions,
  salaryRateTypeOptions,
  searchOptionOptions,
  searchTypeOptions,
} from '../utils/CWJobsHelper';

interface AdvanceFilterNewProps {
  performSearch: (values: BasicSearchForm & CareerBuilderAdvanceSearch) => void;
}

const AdvancedFiltersNew = ({ performSearch }: AdvanceFilterNewProps) => {
  const methods = useFormContext();
  const { handleSubmit, reset } = methods;
  return (
    <FormProvider {...methods}>
      <Paper sx={{ mt: 2 }}>
        <Box
          component="form"
          role="presentation"
          onSubmit={handleSubmit(performSearch as SubmitHandler<FieldValues>)}
          onReset={() => reset()}
        >
          <AdvancedFiltersHeader />
          <Divider />
          <List>
            <WsAccordion
              title="Search Type"
              startIcon={<LuSearch color={WsColors.TertiaryShades800} />}
            >
              <WsSelect name="searchType" selectArray={searchTypeOptions} placeholder="Select" />
            </WsAccordion>

            <WsAccordion
              title="Search Options"
              startIcon={<LuSearch color={WsColors.TertiaryShades800} />}
            >
              <WsSelect
                name="searchOption"
                selectArray={searchOptionOptions}
                placeholder="Select"
              />
            </WsAccordion>
            <WsAccordion
              title="Salary"
              startIcon={<HiOutlineBanknotes color={WsColors.TertiaryShades800} />}
            >
              <WsSelect
                name="salary.salaryRateType"
                selectArray={salaryRateTypeOptions}
                label="Rate Type"
              />
              <Box>
                <Stack direction="row" spacing={2}>
                  <WsInputNumber name="salary.from" label="Min" />
                  <WsInputNumber name="salary.to" label="Max" />
                </Stack>
              </Box>
            </WsAccordion>

            <CheckboxListFilter
              name="languages"
              options={languagesCheckBoxOptions}
              title="Languages"
              startIcon={<LuLanguages color={WsColors.TertiaryShades800} />}
            />

            <CheckboxListFilter
              name="highestLevelOfEducation"
              options={highestLevelOfEducationCheckBoxOptions}
              title="Level of Education"
              startIcon={<LuGraduationCap color={WsColors.TertiaryShades800} />}
            />

            <CheckboxListFilter
              name="countries"
              options={countriesCheckBoxOptions}
              title="Countries"
              startIcon={<LuGlobe color={WsColors.TertiaryShades800} />}
            />

            <WsAccordion
              title="Job Hours"
              startIcon={<LuFileClock color={WsColors.TertiaryShades800} />}
            >
              <WsSelect name="jobHours" selectArray={jobHoursOptions} placeholder="Select" />
            </WsAccordion>

            <WsAccordion
              title="Hide Candidate Viewed Since"
              startIcon={<LuEyeOff color={WsColors.TertiaryShades800} />}
            >
              <WsSelect
                name="HideCandidatesViewedSince"
                selectArray={HideCandidatesViewedSinceOptions}
                placeholder="Select"
              />
            </WsAccordion>
            <WsAccordion
              title="Willing to Relocate"
              startIcon={<LuMap color={WsColors.TertiaryShades800} />}
            >
              <WsSelect name="relocate" selectArray={relocateOptions} placeholder="Select" />
            </WsAccordion>
          </List>
        </Box>
      </Paper>
    </FormProvider>
  );
};

export default AdvancedFiltersNew;
